module.exports = __webpack_public_path__ + "static/img/half_pitch_grey.c9fb720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/half_pitch_grey.png
// module id = 0LPn
// module chunks = 79